export type BaseTreasure = {
  id: number;
  name: string;
  amountTon: number;
  payoutTon: number;
  roiPercent: number;
  cycleHours: number;
  unlocked: boolean;
};

export const TREASURES: BaseTreasure[] = [
  { id: 1, name: 'Starter Treasure', amountTon: 0.4, payoutTon: 0.44, roiPercent: 10, cycleHours: 13, unlocked: true },
  { id: 2, name: 'Bronze Treasure', amountTon: 0.6, payoutTon: 0.66, roiPercent: 10, cycleHours: 16, unlocked: false },
  { id: 3, name: 'Silver Treasure', amountTon: 0.9, payoutTon: 0.99, roiPercent: 10, cycleHours: 19, unlocked: false },
  { id: 4, name: 'Gold Treasure', amountTon: 1.3, payoutTon: 1.43, roiPercent: 10, cycleHours: 22, unlocked: false },
  { id: 5, name: 'Ruby Treasure', amountTon: 1.8, payoutTon: 1.98, roiPercent: 10, cycleHours: 25, unlocked: false },
  { id: 6, name: 'Emerald Treasure', amountTon: 2.4, payoutTon: 2.64, roiPercent: 10, cycleHours: 28, unlocked: false },
  { id: 7, name: 'Sapphire Treasure', amountTon: 3.1, payoutTon: 3.41, roiPercent: 10, cycleHours: 31, unlocked: false },
  { id: 8, name: 'Diamond Treasure', amountTon: 3.9, payoutTon: 4.29, roiPercent: 10, cycleHours: 34, unlocked: false },
  { id: 9, name: 'Platinum Treasure', amountTon: 4.8, payoutTon: 5.28, roiPercent: 10, cycleHours: 37, unlocked: false },
  { id: 10, name: 'Lord Treasure', amountTon: 7, payoutTon: 8.05, roiPercent: 15, cycleHours: 40, unlocked: false },
  { id: 11, name: 'Hard Treasure', amountTon: 10, payoutTon: 11.5, roiPercent: 15, cycleHours: 43, unlocked: false },
  { id: 12, name: 'Loyal Treasure', amountTon: 15, payoutTon: 17.25, roiPercent: 15, cycleHours: 46, unlocked: false },
  { id: 13, name: 'Coming Soon', amountTon: 999, payoutTon: 999, roiPercent: 0, cycleHours: 999, unlocked: false },
];


